import { createSelector } from '@ngrx/store';
import { callParkingLotRegiserSelector } from './call-parkinglot-register.reducer';

export const selectFilters = createSelector(callParkingLotRegiserSelector, (state) => {
   return state.filters;
});
